import React, {useEffect} from 'react'
import {withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import TitledComponent from 'components/TitledComponent';
import RadioGroup from 'components/RadioGroup';
import Tr from 'translations/Translations';
import Select from 'components/Select';
import GridBlock from 'components/GridBlock';
import periodValues from './constants/period.values'
import getObjectValue from 'libs/getObjectValue'
import DatePicker from 'components/DatePicker';

const style = theme => ({
    root: {
        marginLeft: theme.spacing(2),
        marginTop: theme.spacing(2)
    }
})

function UpdatedDateBind(
    {
        classes,
        formikProps,
        title,
        initialPickDateInsteadOfPeriod
    }) {

    const radioId = 'updatedBindWithOfferPeriodOrDate.pickDateInsteadOfPeriod'
    const dateId = "updatedBindWithOfferPeriodOrDate.date"

    const conditionalValue = getObjectValue(radioId, formikProps.values, '')

    useEffect(() => {
        if (conditionalValue === "true") formikProps.setFieldTouched(dateId, true)
        // eslint-disable-next-line
    }, [conditionalValue])


    const getRadioValues = () => {
        const values = [
            {label: Tr('not_applicable'), value: "empty"},
            {label: Tr('date'), value: "true"},
        ]
        if(initialPickDateInsteadOfPeriod === 'false') {
            values.push({label: Tr('period'), value: "false"})
        }
        return values;
    }

    return (
        <TitledComponent
            className={classes.root}
            title={title}
        >
            <GridBlock
                column
            >
                <RadioGroup
                    id={radioId}
                    formikProps={formikProps}
                    items={getRadioValues()}
                />
                {
                    conditionalValue === "empty" ? ""
                        : (conditionalValue === 'true' ?
                        <DatePicker
                            formikProps={formikProps}
                            id={dateId}
                        /> :
                        <Select
                            formikProps={formikProps}
                            id={'updatedBindWithOfferPeriodOrDate.period.length'}
                            items={periodValues}
                        />)
                }
            </GridBlock>
        </TitledComponent>
    )
}

UpdatedDateBind.propTypes = {
    classes: PropTypes.any,
}

export default withStyles(style)(UpdatedDateBind);